import React from 'react';
import Footer from './Footer';
import Header from './Header';
import {  MapContainer, TileLayer, useMap } from 'react-leaflet';
import { CssBaseline } from '@material-ui/core';
import L from 'leaflet';


function Pop() {

    const map = useMap();

    L.popup({
        closeOnClick: false
      })
      .setLatLng([46.227638, 2.213749])
      .setContent('Le technicien est en cours d’intervention, sa géolocalisation n’est plus disponible.')
      .addTo(map);
      return null;
}


function Mapp() {
    const position = [46.227638, 2.213749];
    const zoom = 6;


    return (
       <div >
 
          <MapContainer center={position} zoom={zoom} style={{  height: "90vh", opacity: 'O,33'}}>
             <TileLayer attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
               <Pop />
          </MapContainer >
         
       </div>);
 };




const ErrorTech = () => {
  
  return (
    <>
     
      <Header />
       < Mapp />
      <Footer />
    </>);
};
export default ErrorTech;
